module.exports = __webpack_public_path__ + "media/flags/dz-f2045402.svg";